<template>
  <div class="flex flex-col offer-detail">
    <div
      class="flex w-full min-h-50 max-h-screen/2"
      v-if="offer && offer.attributes"
    >
      <img class="object-cover w-full h-max" :src="imageUrl" />
    </div>
    <div
      class="min-h-50 px-4 lg:px-8 lg:w-screen-lg max-w-screen-lg mx-auto text-left space-y-6 mt-10"
      v-if="offer && offer.attributes"
    >
      <p class="title text-np-56 lg:text-np-3xl text-np-glimpse">
        {{ offer.attributes.title }}
      </p>
      <content-body :source="offer.attributes.body.content" />
    </div>
    <gallery-slide
      v-if="galleries && galleries.length > 0"
      :images="galleries"
      class="my-18 lg:my-20"
    />
    <share-items />
    <special-item
      v-if="offer && offer.attributes"
      title-list="other offers"
      type="offer"
      :subType="offer.attributes.type.data.id"
      :exclude-id="offer.id"
    />
  </div>
</template>

<script>
import { getOfferBySlug } from "@/api/endpoints/offers";
import to from "await-to-js";
import SpecialItem from "@/components/SpecialItem.vue";
import ShareItems from "@/components/ShareItems.vue";
import ContentBody from "../../components/ContentBody.vue";
import GallerySlide from "../../components/gallery/GallerySlide.vue";
import { getImageUrl } from "@/utils/imageUtils.js";

export default {
  name: "OfferDetail",
  data() {
    return {
      lang: "en",
      offer_id: 0,
      offer: {},
      galleries: [],
    };
  },
  components: {
    SpecialItem,
    ShareItems,
    ContentBody,
    GallerySlide,
  },
  async mounted() {
    let offer_id = this.$route.params.offer_id;
    this.offer_id = offer_id;
    await this.setOfferDetail(this.lang, offer_id);
  },
  watch: {
    "$route.params.offer_id": {
      handler: async function (offer_id) {
        await this.setOfferDetail(this.lang, offer_id);
        window.scrollTo({ top: 0, behavior: "smooth" });
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    imageUrl() {
      return this.offer.attributes.image.data.attributes.url;
      // if (this.offer.attributes.image.data.attributes.formats) {
      //   if (
      //     this.offer.attributes.image.data.attributes.formats.large &&
      //     this.offer.attributes.image.data.attributes.formats.large.url
      //   )
      //     return this.offer.attributes.image.data.attributes.formats.large.url;
      //   if (
      //     this.offer.attributes.image.data.attributes.formats.small &&
      //     this.offer.attributes.image.data.attributes.formats.small.url
      //   )
      //     return this.offer.attributes.image.data.attributes.formats.small.url;
      //   if (
      //     this.offer.attributes.image.data.attributes.formats.thumbnail &&
      //     this.offer.attributes.image.data.attributes.formats.thumbnail.url
      //   )
      //     return this.offer.attributes.image.data.attributes.formats.thumbnail
      //       .url;
      // }
      // return "";
    },
  },
  methods: {
    async setOfferDetail(lang, offerId) {
      const [err, response] = await to(getOfferBySlug(lang, offerId));

      if (err) {
        return { errorMessage: err?.response?.data?.error || err.message };
      }
      this.offer = response.data.data[0];
      if (this.offer.attributes.body.images) {
        this.galleries = this.offer.attributes.body.images.data.map((img) => {
          return {
            id: img.id,
            image_url: getImageUrl(img),
          };
        });
      } else {
        this.galleries = [];
      }
    },
  },
};
</script>

<style scoped>
.title {
  font-family: "Saol Text" !important;
  font-style: normal;
}

.menu {
  font-family: "Saol Text" !important;
  font-style: normal;
  font-weight: 300;
  font-size: 24px;
  line-height: 28px;
  color: #5c623f;
}

#experience-content {
  border-top: 1px solid #cecdc8;
}

.discover-more {
  background: #5c623f;
  color: white;
}

.description {
  font-style: normal;
  font-weight: 300;
  color: #000000;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>
